import { StateBadge } from '@shared/ui/StateBadge';

import { stateLabels } from './copy';
import { STATE_BADGE_KIND } from './states';
import type { EditorialState } from './types';

/**
 * The post's state, in one component so the four surfaces cannot disagree about
 * which colour a state takes or how it is spelt.
 *
 * **The badge is the single source of a row's state** — the row menu derives
 * what it offers by reading the same value this renders, so what the menu
 * offers cannot drift from what the row shows.
 *
 * A value the five-member machine does not carry renders `neutral` with its
 * literal label rather than crashing or vanishing: the badge taxonomy is closed
 * while a vocabulary can grow, and a state nobody mapped is still a state the
 * operator has to be able to read.
 */
export function PostStateBadge({ state }: { state: EditorialState }) {
  return <StateBadge kind={STATE_BADGE_KIND[state] ?? 'neutral'}>{stateLabels[state] ?? state}</StateBadge>;
}
